// extracted by mini-css-extract-plugin
export var brandShape = "styles-module--brand-shape--WgJgT";
export var extraInput = "styles-module--extra-input--eAEHD";
export var halfWidthContainer = "styles-module--half-width-container--sjl3Y";
export var inputClickButton = "styles-module--input-click-button--iqdjf";
export var inputHeader = "styles-module--input-header--iyV9h";
export var inputSliceContainer = "styles-module--input-slice-container--v8oK5";
export var primary = "#06004d";
export var secondary = "#4dafd7";